module.exports = __webpack_public_path__ + "img/img_company_opinion1.96d3d313.svg";